export const NAMESPACE = 'payment';
export const PATH = NAMESPACE;
